import createInformesSectionPage from "./SectionPageFactory";

const InformesGerenciaPage = createInformesSectionPage(
  "Gerencia",
  "Mantén a la dirección informada con KPIs integrados y reportes ejecutivos."
);

export default InformesGerenciaPage;
